import { BaseService } from '@/modules/Core/services/BaseService'
import type { IMediEquivalencias } from '@/modules/Farmacia/interfaces/tablas/IMediEquivalencias'

export class EquivalenciasService extends BaseService<IMediEquivalencias> {
  constructor () {
    super({
      baseUrl: 'medicines/medicines/equivalencias/'
    })
  }
}
